import { useAppSelector } from "../../../redux/hook";
import { downloadFile } from "../../../utils/download-file";
import { PdfIconV2 } from "../../../assets/svg";

import { useGetFinancialPlanQuery } from "../../../redux/services/getStageE";
import { Helpers } from "../../../utils/helper";

function FinancialPlan() {
  const singpassToken = useAppSelector(
    (state) => state.auth.AuthenticationSlice.singpassToken
  );
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get("application_id");
  const loginUser = useAppSelector(
    (state) => state.auth.AuthenticationSlice.loginUser
  );

  function handleDownloadFinancialPlan(e: any) {
    e.preventDefault();
    if (financialPlan) {
      downloadFile(financialPlan?.key, singpassToken);
    }
  }

  const { data: financialPlan } = useGetFinancialPlanQuery({
    application_id: application_id ?? "0",
    uinfin: loginUser.uinfin ?? "",
    singpass_token: singpassToken ?? "0",
  });

  return (
    <div style={{ margin: "16px 0" }}>
      <div className="d-flex flex-row justify-content-start align-items-center polymer-stage-e-icon-gap">
        <div
          className="d-flex flex-column flex-sm-row justify-content-between"
          style={{ flex: 1, gap: "16px" }}
        >
          {financialPlan && (
            <>
              <div
                style={{
                  fontSize: "18px",
                  lineHeight: "24px",
                  verticalAlign: "bottom",
                  margin: "0px",
                }}
              >
                <div className="d-flex align-items-end">
                  <a
                    className="polymer-text-links"
                    onClick={(e) => {
                      handleDownloadFinancialPlan(e);
                    }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Financial Plan
                  </a>
                  <PdfIconV2 color={"#0A676D"} />
                </div>
              </div>
              <div className="financial-plan-details">
                Prepared by HDB on{" "}
                <span>
                  {Helpers.formatDate(
                    financialPlan?.submitted_date,
                    "long",
                    true
                  )}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default FinancialPlan;
